export const FIRM_DOCUMENT_REQUESTED_FILES_QUERY_KEY = 'firm-document-requested-files';
export const FIRM_DOCUMENT_REQUESTED_FILES_QUERY_STALE_TIME_MS = 60_000;
